import { gtagWrapper } from '../google-analytics/utils';
import { getStoredEvents, RECOVERED, removeStoredEvent } from './eventStorage';

export { pushStoredEvent, removeStoredEvent } from './eventStorage';

/**
 * Recover events stored and not triggered in previous pages
 * @param interval - interval in ms to wait between each event recovery, default is 1000ms
 */
export const recoverStoredEvents = (interval = 1000) => {
  const processNextEvent = () => {
    const storedEvents = getStoredEvents();
    const keys = Object.keys(storedEvents);
    if (!keys.length) {
      return;
    }
    const uuid = keys[0];
    const [command, eventName, params] = storedEvents[uuid];
    gtagWrapper(command, eventName, { ...params, misc: RECOVERED });
    removeStoredEvent(uuid);
    setTimeout(processNextEvent, interval);
  };
  processNextEvent();
};
